import { isNil } from 'ramda';
import * as React from 'react';

import styles from './index.css';
import { NBSP } from '../../constants';
import { trackOpenRoadsLink } from '../../tracking';
import { IRoadInfoSchema } from '../../types';
import { getDistanceHighway } from '../../utils/helpers';
import { HighwayIcon } from '../common/icons';

export const RoadCommuteRow = (roadItem: IRoadInfoSchema, regionId?: number) => {
  if (!roadItem && isNil(regionId)) {
    return null;
  }

  const link = roadItem.seo ? roadItem.seo.url : '';

  return (
    <div className={styles['commute']}>
      <span className={styles['commute-icon']}>
        <HighwayIcon />
      </span>
      <a className={styles['address-link']} href={link} onClick={trackOpenRoadsLink} target="_blank">
        <span>{roadItem.name}</span>
      </a>
      ,{NBSP}
      <span className={styles['commute-distance']}>{getDistanceHighway(roadItem, regionId)}</span>
    </div>
  );
};
